import React, { Component } from 'react';


class Adsense extends Component {

    constructor(props)
    {
        super(props);
        this.Debug = false;
    }

    componentDidMount() {
        if(this.Debug === false)
        {
            if(window) (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
    }

    render() {

        if(this.Debug === true)
        {
            return (<div></div>);
        }
        else {

            return (
                <ins className="adsbygoogle"
                     style={this.props.style}
                     data-ad-layout={this.props.layout}
                     data-ad-client={this.props.client}
                     data-ad-slot={this.props.slot}
                     data-ad-format={this.props.format} />
            );
        }


    }
}


export default Adsense;



// WEBPACK FOOTER //
// ./src/include/_adsense.js